import { defineComponent } from "vue";
import Header from '@/components/header.vue';
export default defineComponent({
  components: {
    'ext-header': Header
  },
  setup: function setup() {}
});